<template>
  <div class="winner-indicator">
    <!-- Trophy avec dropdown au click -->
    <VaDropdown placement="bottom-start" class="winner-dropdown">
      <template #anchor>
        <button class="winner-button">🏆 Winner du moment</button>
      </template>

      <div class="winner-content-dropdown">
        <div v-if="winner.userId" class="winner-content">
          <div class="winner-name">{{ winner.firstName }} {{ winner.lastName }}</div>
          <div class="winner-count">
            <strong>{{ winner.attestationCount }}</strong> attestation{{ winner.attestationCount > 1 ? 's' : '' }}
          </div>
          <div v-if="isCurrentUserWinner" class="current-winner-badge">⭐ C'est vous !</div>
        </div>
        <div v-else class="no-winner">Aucun winner pour le moment</div>
      </div>
    </VaDropdown>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { VaDropdown } from 'vuestic-ui'
import { useUserStore } from '../../../stores/user-store'
import { attestationStatsService, type Winner } from '../../../services/AttestationStatsService'

const userStore = useUserStore()
const winner = ref<Winner>({
  userId: null,
  lastName: 'Aucun',
  firstName: '',
  attestationCount: 0,
})

const isCurrentUserWinner = computed(() => {
  return (
    winner.value.userId &&
    userStore.userId &&
    winner.value.userId === userStore.userId &&
    winner.value.attestationCount > 0
  )
})

onMounted(async () => {
  // Charge le winner initial
  const initialWinner = await attestationStatsService.fetchLeaderStats()
  winner.value = initialWinner

  // Démarre le polling pour les mises à jour en temps réel (toutes les 15s)
  attestationStatsService.startPolling(15000)
})

onUnmounted(() => {
  // Arrête le polling
  attestationStatsService.stopPolling()
})
</script>

<style lang="scss" scoped>
.winner-indicator {
  display: flex;
  align-items: center;
}

.winner-button {
  background: transparent;
  border: none;
  color: var(--va-primary);
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(var(--va-primary-rgb), 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
  }
}

.winner-content-dropdown {
  padding: 16px 20px;
  min-width: 240px;
}

.winner-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}

.winner-name {
  font-weight: 600;
  font-size: 1rem;
  color: var(--va-text-primary);
}

.winner-count {
  font-size: 0.9rem;
  color: var(--va-text-secondary);

  strong {
    color: var(--va-warning);
    font-weight: 700;
  }
}

.current-winner-badge {
  margin-top: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, var(--va-success) 0%, var(--va-info) 100%);
  color: white;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.no-winner {
  color: var(--va-text-secondary);
  font-size: 0.9rem;
  text-align: center;
}
</style>
